export default (foo) => foo;


// WEBPACK FOOTER //
// ./src/helpers/foo.js